import { JsonLd } from "react-schemaorg";
import { Helmet } from "react-helmet";
import {
  productIsPerSquareMeter,
  StatusCodes,
  useProductUrl
} from "../../utils/ProductUtils";
import { addVat } from "../../utils/VatUtils";

function availabilityFromStockStatus(status) {
  const schemaBase = "https://schema.org/";
  switch (status) {
    case StatusCodes.readyToShip:
      return schemaBase + "InStock";
    case StatusCodes.backOrder:
      return schemaBase + "LimitedAvailability";
    case StatusCodes.soldOut:
      return schemaBase + "SoldOut";
    case StatusCodes.outOfStock:
      return schemaBase + "OutOfStock";
    default:
      return null;
  }
}
function merchantAvailabilityFromStockStatus(status) {
  switch (status) {
    case StatusCodes.readyToShip:
    case StatusCodes.backOrder:
      return "in_stock";
    case StatusCodes.soldOut:
    case StatusCodes.outOfStock:
      return "out_of_stock";
    default:
      return null;
  }
}

const ProductSchema = ({ product, lang = "en" }) => {
  const {
    name,
    images,
    description,
    seo_title,
    seo_description,
    sku,
    gtin13,
    categories,
    brand: brandData,
    price: productPrice,
    unitQuantityFactor,
    stock
  } = product;
  const stockStatus = stock?.status;
  const { basePrice, currency: priceCurrency } = productPrice || {};
  const isPerSquareMeter = productIsPerSquareMeter(unitQuantityFactor);
  const price = addVat(basePrice);

  const imageURLs = images.map(
    image => window.location.protocol + image.styles.medium || image.path
  );
  const firstImage = imageURLs.length > 0 ? imageURLs[0] : "";
  const otherImages = imageURLs.length > 1 ? imageURLs.slice(1) : [];
  const brand = brandData
    ? {
        "@type": "Brand",
        name: brandData
      }
    : null;
  const url =
    window.location.origin +
    "/" +
    lang +
    useProductUrl({ name, sku, categories });
  const item = {
    "@context": "https://schema.org",
    "@type": "Product",
    name,
    title: name, //for Google Merchant
    image: imageURLs,
    imageLink: firstImage, //for Google Merchant
    additionalImageLinks: otherImages, //for Google Merchant
    description,
    sku,
    id: sku, //for Google Merchant
    mpn: sku,
    gtin13,
    gtin: gtin13, //for Google Merchant
    brand,
    url,
    link: url, //for Google Merchant
    price: price + " " + priceCurrency, //for Google Merchant
    ...(isPerSquareMeter && {
      unit_pricing_measure: unitQuantityFactor + " sqm", //for Google Merchant
      unit_pricing_base_measure: "1 sqm" //for Google Merchant
    }),
    condition: "new", //for Google Merchant
    availability: merchantAvailabilityFromStockStatus(stockStatus), //for Google Merchant
    offers: {
      "@type": "Offer",
      url,
      price,
      priceCurrency,
      itemCondition: "https://schema.org/NewCondition",
      availability: availabilityFromStockStatus(stockStatus),
      seller: {
        "@type": "Organization",
        name: "Bjelin" //TODO dynamic seller, maybe site? Bjelin.se
      }
    }
  };
  return item.availability ? (
    <>
      <JsonLd item={item} />
      <Helmet>
        <meta property="og:site_name" content={"Bjelin"} />
        <meta property="og:url" content={url} />
        <meta property="og:type" content={"website"} />
        <meta property="og:title" content={name} />
        <meta name="title" content={seo_title || "Bjelin " + name} />
        <meta property="og:description" content={description} />
        <meta name="description" content={seo_description || description} />
        <meta property="og:image" content={imageURLs} />
        {/*<meta property="fb:app_id" content={} />*/}
      </Helmet>
    </>
  ) : null;
};

export default ProductSchema;
